const styles = (theme) => ({
  root: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  closeBtn: {
    position: 'absolute',
    top: theme.spacing(1.5),
    left: theme.spacing(1),
    zIndex: 1000,
  },
});

export default styles;
